import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDiagonsis } from "../../redux/questions/painQuestionsSlice";
import { ScreenContainer, Text, DiagnosisProgressCard, DiagnosisDescriptionCard } from "../../components";
import './DiagnosisResults.scss';
import { useTranslation } from "react-i18next";
import cx from "classnames";
import { fetchTreatments } from "../../redux/APIs";

const DiagnosisResults = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const diagnosis = useSelector(getDiagonsis);
  const { t } = useTranslation();
  const [selectedCard, setSelectedCard] = useState(null);
  const token = localStorage.getItem("token");
  
  const onClick = () => {
    fetchTreatments(dispatch, diagnosis[selectedCard].diagnosticId, diagnosis[selectedCard].possibleDiagnostic);
    if (token) {
      Navigate("/treatmentLoading");
    } else {
      Navigate("/login");
    }
  }
  return (
    <ScreenContainer>
      <div className="ResultsTopTitleBar">
        <Text variant="Heading3">{t("diagnosisResultsHeading")}</Text>
      </div>
      <div className="ResultsContent">
        <div className="ResultsDescriptionContainer">
          <div className="ResultsCardContent">
            {diagnosis && diagnosis?.length
              ? diagnosis?.map((element, index) => (
                <DiagnosisProgressCard key={element.possibleDiagnostic} element={element} index={index} onClick={id => setSelectedCard(id)} selectedCard={selectedCard} />
              )) : null}
          </div>
        </div>
        <div className="ResultsDivider" />
        <div className="ResultsDescriptionContainer" onClick={() => {
          setSelectedCard(null);
        }}>
          <div
            className={cx("ResultsDescriptionContent", {
              "ResultsDescriptionContentShow": selectedCard !== null
            })}
          >
            {selectedCard !== null && <DiagnosisDescriptionCard index={selectedCard} selectedCard={diagnosis[selectedCard]} onClick={onClick} />}
          </div>
        </div>
      </div>
    </ScreenContainer>
  );
};

export default DiagnosisResults;
